// Faqpage accordion js
 $(document).on("click", ".accordion__button", function () {
  if ($(this).parent().hasClass("active")) {
    $(this).parent().removeClass("active");
    $(this).parent().find(".faq__answerWrapper").slideUp();
  } else {
    $(".faq_accordion_itemWrapper").removeClass("active");
    $(".faq__answerWrapper").slideUp();
    $(this).parent().toggleClass("active");
    $(this).parent().find(".faq__answerWrapper").slideToggle();
  }
});
